import { render, staticRenderFns } from "./InventoryTemplatesComponent.vue?vue&type=template&id=5e977492&scoped=true&"
import script from "./InventoryTemplatesComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryTemplatesComponent.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTemplatesComponent.vue?vue&type=style&index=0&id=5e977492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e977492",
  null
  
)

export default component.exports